import { errorNotifier } from "../../../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../../../services/api";

export const initializePayment = async (
  payload
  // , nextStep, setPaymentLoading, setPaymentData, setPaymentModal
) => {
  try {
    const result = await http.post(AUTH_ROUTES.INITIALIZE_PAYMENT, payload);
    console.log(result?.data?.payment?.data, "initilaize");
    // nextStep()
    // setPaymentLoading(false)
    // setPaymentData(result?.data?.payment?.data)
    // setPaymentModal(true)
    // successNotifier("Purchase successful")
    return result?.data.payment.data;
  } catch (e) {
    console.log("error", e.response);
    throw e;
  }
};
